import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { LocateUserUseCase } from './LocateUserUseCase';
import { GenerateEmailVerifcationPinUseCase } from './GenerateEmailVerifcationPinUseCase';
import { VerifyEmailVerifcationPinUseCase } from './VerifyEmailVerifcationPinUseCase';
import { LoginStep1UseCase } from './LoginStep1UseCase';
import { LoginCredentialsUseCase } from './LoginCredentialsUseCase';
import { LoginWithTokenUseCase } from './LoginWithTokenUseCase';
import { LegacyMigrateGenerateUseCase } from './LegacyMigrateGenerateUseCase';
import { ForgotPasswordGeneratePinByEmailUseCase } from './ForgotPasswordGeneratePinByEmailUseCase';
import { ForgotPasswordGeneratePinByMsisdnUseCase } from './ForgotPasswordGeneratePinByMsisdnUseCase';
import { ForgotPasswordUpdatePasswordByEmailUseCase } from './ForgotPasswordUpdatePasswordByEmailUseCase';
import { ForgotPasswordUpdatePasswordByMsisdnByUseCase } from './ForgotPasswordUpdatePasswordByMsisdnByUseCase';
import { ForgotPasswordVerifyPinByEmailUseCase } from './ForgotPasswordVerifyPinByEmailUseCase';
import { ForgotPasswordVerifyPinByMsisdnUseCase } from './ForgotPasswordVerifyPinByMsisdnUseCase';
import { GeneratePinUseCase } from './GeneratePinUseCase';
import { GetCountryConfigsUseCase } from './GetCountryConfigsUseCase';
import { InternalVerifyUserUseCase } from './InternalVerifyUserUseCase';
import { LegacyMigrateUseCase } from './LegacyMigrateUseCase';
import { LegacyMigrateVerifyUseCase } from './LegacyMigrateVerifyUseCase';
import { LoginOtpStep1UseCase } from './LoginOtpStep1UseCase';
import { LoginOtpStep2UseCase } from './LoginOtpStep2UseCase';
import { PaymentSwitchGenerateUseCase } from './PaymentSwitchGenerateUseCase';
import { PaymentSwitchVerifyUseCase } from './PaymentSwitchVerifyUseCase';
import { QrAuthenticateCodeUseCase } from './QrAuthenticateCodeUseCase';
import { QrCodeLoginUseCase } from './QrCodeLoginUseCase';
import { QrCodePairingUseCase } from './QrCodePairingUseCase';
import { QrGenerateCodeUseCase } from './QrGenerateCodeUseCase';
import { ResetPasswordStep1UseCase } from './ResetPasswordStep1UseCase';
import { ResetPaswordStep2UseCase } from './ResetPaswordStep2UseCase';
import { ResubscribeCreditCardUseCase } from './ResubscribeCreditCardUseCase';
import { ResubscribeOtpSendUseCase } from './ResubscribeOtpSendUseCase';
import { ResubscribeOtpVerifyUseCase } from './ResubscribeOtpVerifyUseCase';
import { SendAccountActivationUseCase } from './SendAccountActivationUseCase';
import { UserUnsubscribeUseCase } from './UserUnsubscribeUseCase';
import { VerifyPinUseCase } from './VerifyPinUseCase';

export const initializeUserUseCases = (container: Container) => {
    container.register(DI.USECASES.ILocateUserUseCase, {
        useClass: LocateUserUseCase,
    });
    container.register(DI.USECASES.IGenerateEmailVerifcationPinUseCase, {
        useClass: GenerateEmailVerifcationPinUseCase,
    });
    container.register(DI.USECASES.IVerifyEmailVerifcationPinUseCase, {
        useClass: VerifyEmailVerifcationPinUseCase,
    });
    container.register(DI.USECASES.ILoginStep1UseCase, {
        useClass: LoginStep1UseCase,
    });
    container.register(DI.USECASES.ILoginCredentialsUseCase, {
        useClass: LoginCredentialsUseCase,
    });
    container.register(DI.USECASES.ILoginWithTokenUseCase, {
        useClass: LoginWithTokenUseCase,
    });
    container.register(DI.USECASES.ILoginOtpStep1UseCase, {
        useClass: LoginOtpStep1UseCase,
    });
    container.register(DI.USECASES.ILoginOtpStep2UseCase, {
        useClass: LoginOtpStep2UseCase,
    });
    container.register(DI.USECASES.IGeneratePinUseCase, {
        useClass: GeneratePinUseCase,
    });
    container.register(DI.USECASES.IVerifyPinUseCase, {
        useClass: VerifyPinUseCase,
    });
    container.register(DI.USECASES.IResetPasswordStep1UseCase, {
        useClass: ResetPasswordStep1UseCase,
    });
    container.register(DI.USECASES.IResetPaswordStep2UseCase, {
        useClass: ResetPaswordStep2UseCase,
    });
    container.register(DI.USECASES.IForgotPasswordGeneratePinByEmailUseCase, {
        useClass: ForgotPasswordGeneratePinByEmailUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordGeneratePinByMsisdnUseCase, {
        useClass: ForgotPasswordGeneratePinByMsisdnUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordVerifyPinByEmailUseCase, {
        useClass: ForgotPasswordVerifyPinByEmailUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordVerifyPinByMsisdnUseCase, {
        useClass: ForgotPasswordVerifyPinByMsisdnUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordUpdatePasswordByEmailUseCase, {
        useClass: ForgotPasswordUpdatePasswordByEmailUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordUpdatePasswordByMsisdnByUseCase, {
        useClass: ForgotPasswordUpdatePasswordByMsisdnByUseCase,
    });
    container.register(DI.USECASES.IQrGenerateCodeUseCase, {
        useClass: QrGenerateCodeUseCase,
    });
    container.register(DI.USECASES.IQrAuthenticateCodeUseCase, { useClass: QrAuthenticateCodeUseCase });
    container.register(DI.USECASES.IQrCodeLoginUseCase, {
        useClass: QrCodeLoginUseCase,
    });
    container.register(DI.USECASES.IQrCodePairingUseCase, {
        useClass: QrCodePairingUseCase,
    });
    container.register(DI.USECASES.IInternalVerifyUserUseCase, { useClass: InternalVerifyUserUseCase });
    container.register(DI.USECASES.ISendAccountActivationUseCase, { useClass: SendAccountActivationUseCase });
    container.register(DI.USECASES.IPaymentSwitchGenerateUseCase, { useClass: PaymentSwitchGenerateUseCase });
    container.register(DI.USECASES.IPaymentSwitchVerifyUseCase, { useClass: PaymentSwitchVerifyUseCase });
    container.register(DI.USECASES.IResubscribeOtpSendUseCase, { useClass: ResubscribeOtpSendUseCase });
    container.register(DI.USECASES.IResubscribeOtpVerifyUseCase, {
        useClass: ResubscribeOtpVerifyUseCase,
    });
    container.register(DI.USECASES.IResubscribeCreditCardUseCase, {
        useClass: ResubscribeCreditCardUseCase,
    });
    container.register(DI.USECASES.IGetCountryConfigsUseCase, {
        useClass: GetCountryConfigsUseCase,
    });
    container.register(DI.USECASES.IUserUnsubscribeUseCase, {
        useClass: UserUnsubscribeUseCase,
    });
    container.register(DI.USECASES.ILegacyMigrateUseCase, {
        useClass: LegacyMigrateUseCase,
    });
    container.register(DI.USECASES.ILegacyMigrateGenerateUseCase, {
        useClass: LegacyMigrateGenerateUseCase,
    });
    container.register(DI.USECASES.ILegacyMigrateVerifyUseCase, {
        useClass: LegacyMigrateVerifyUseCase,
    });
};
